// extracted by mini-css-extract-plugin
module.exports = {"heading":"Support_heading__2dGzk","searchContainer":"Support_searchContainer__3m3C6","markdown":"Support_markdown__3P_f6"};